export default {"src":"/_next/static/media/spicy.baa9b3d0.svg","height":16,"width":16};